var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLexicalDecision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 52,
    height: 72,
    rx: 4,
    fill: "#C75E5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 8,
    height: 72,
    rx: 2,
    fill: "#A8504D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 40,
    height: 64,
    rx: 2,
    fill: "#FAC1B5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 28,
    x2: 64,
    y2: 28,
    stroke: "#F9907B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 36,
    x2: 58,
    y2: 36,
    stroke: "#F9907B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 44,
    x2: 62,
    y2: 44,
    stroke: "#F9907B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 52,
    x2: 56,
    y2: 52,
    stroke: "#F9907B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 60,
    x2: 60,
    y2: 60,
    stroke: "#F9907B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 68,
    x2: 52,
    y2: 68,
    stroke: "#F9907B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexicalDecision);
export default __webpack_public_path__ + "static/media/LexicalDecision.1d4a6004c825e35263371d6ba25c36b0.svg";
export { ForwardRef as ReactComponent };